import React, {FC} from 'react'
import DetailsReporting from '../../DetailsReporting'
import { translateBase, icon } from '../helpers'
import { ReportsTabProps } from '../types'

const Reports: FC<ReportsTabProps> = ({ data, ID, hash } ) =>
  //@ts-ignore
  <DetailsReporting data={data} ID={ID} hash={hash} type="Client" />


Reports.defaultProps = {
  data: [],
}

//@ts-ignore
Reports.config = {
  title: () => translateBase('tb_udr'),
  name: 'reports',
  component: Reports,
  api: { page: 'reports', permission: 'ForNotToAutoFetch' },
  icon: icon('tb_udr'),
}

export default Reports
